import { useContext, useEffect, useState } from "react"

import { ObjectList } from "web/components"
import useDocumentAfterUploadSingleModal from "web/pages/Documents/AfterUploadSingle"

import { useAddAccountAttachment, useCurrentUser } from "web/hooks/data"

import { NavigationContext } from "web/contexts"

import routes from "web/routes/constants"

import { HandThumbDownIcon, XCircleIcon } from "@heroicons/react/24/outline"

export default function ListDeals({ rootUrl }) {
  const currentUser = useCurrentUser()
  const [fileDropZoneActive, setFileDropZoneActive] = useState(true)

  const { viewGroup, viewId } = useContext(NavigationContext)

  const addAccountAttachment = useAddAccountAttachment()

  const afterUploadSingleModal = useDocumentAfterUploadSingleModal()

  function addNewDeal() {
    window.Turbo.visit("/deals/asset_selection/new", { frame: "modal" })
  }

  useEffect(() => {
    document.addEventListener("dialog-modal:close", () => {
      setFileDropZoneActive(true)
    })

    return () => {
      document.removeEventListener("dialog-modal:close", () =>
        setFileDropZoneActive(true)
      )
    }
  }, [])

  function goToDeal(deal) {
    window.Turbo.visit(routes.deal(viewGroup.slug, viewId, deal.id))
  }

  async function filesDropped(files) {
    if (currentUser.cannot("create", "deal")) {
      return false
    }

    const attachments = await addAccountAttachment(files)

    if (!attachments.length === 1) return

    const attachment = attachments[0]
    const response = await afterUploadSingleModal(attachment)

    if (response && response === "NEW DEAL") {
      setFileDropZoneActive(false)

      window.Turbo.visit(
        `/deals/asset_selection/new?file_identity_id=${attachment.file_identity_id}`,
        { frame: "modal" }
      )
    }

    if (response && response === "GO TO DEAL") {
      window.Turbo.visit(
        routes.deal(viewGroup.slug, viewId, attachment["matching_deal_id"])
      )
    }
  }

  const onAdd = currentUser.can("create", "deal") ? addNewDeal : undefined

  function openBulkOutcomeModal(outcome, selectedDeals) {
    const editUrl = routes.bulkEditDealOutcome(outcome, {
      "ids[]": selectedDeals.map((deal) => deal.id),
    })

    window.Turbo.visit(editUrl, { frame: "modal" })
  }

  const selectedItemActions = [
    {
      label: "Move to Passed",
      action: ({ selected: deals }) => openBulkOutcomeModal("passes", deals),
      icon: HandThumbDownIcon,
    },
    {
      label: "Move to Lost",
      action: ({ selected: deals }) => openBulkOutcomeModal("losses", deals),
      icon: XCircleIcon,
    },
  ]

  return (
    <ObjectList
      rootUrl={rootUrl}
      subjectType="deal"
      availableViews={["table", "cards", "map", "compare", "overview"]}
      defaultView="table"
      onAdd={onAdd}
      onItemClick={goToDeal}
      onFilesDropped={filesDropped}
      fileDropZoneActive={fileDropZoneActive}
      enableScheduledExport={true}
      enableLocationIndex={true}
      selectedItemActions={
        currentUser.can("update", "deal") && selectedItemActions
      }
    />
  )
}
